import { inTestEnvironment } from 'shared/javascripts/util/environment'

up.compiler('.form-check', (element: HTMLElement) => {
  const label = element.querySelector('label')
  const input = element.querySelector<HTMLInputElement>(
    'input[type="checkbox"], input[type="radio"]',
  )

  if (label && input) {
    input.classList.add('custom-control-input')
    label.classList.add('custom-control-label')
    element.classList.add('custom-control', `custom-${input.getAttribute('type')}`)
    if (inTestEnvironment()) input.classList.add('-test')
  }

  if (element.matches('.form-check-inline')) {
    element.classList.remove('form-check-inline')
    element.classList.add('custom-control-inline')
  }

  up.on(element, 'click', (event: MouseEvent) => {
    // When the container element is clicked directly (i.e. the gap between control and label), nothing would happen.
    // The user actually wanted to click the control, so we do that.
    if (element.isEqualNode(event.target as Node)) {
      input?.click()
    }
  })
})
